import React from "react";
import Logo from "../../assets/4332832.png";
import { NavLink } from "react-router-dom";
import "./navbar.scss";
import RightLeague from "../soccer/RightLeague";

const Navbar = () => {
  return (
    <div>
      <nav className="navbar navbar-expand-lg navbar-light  bg-dark">
        <a className="navbar-brand" href="/">
          <img src={Logo} width="100" height="40" alt="" />
        </a>
        <button
          className="navbar-toggler"
          type="button"
          data-toggle="collapse"
          data-target="#navbarTogglerDemo02"
          aria-controls="navbarTogglerDemo02"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        <div className="collapse navbar-collapse" id="navbarTogglerDemo02">
          <div className="rightleague">
            <RightLeague />
          </div>

          {/* <ul className="navbar-nav ml-auto mt-2 mt-lg-0">
            <li className="nav-item mr-3">
              <NavLink
                exact
                to="/"
                className="nav-link font-weight-bold text-white"
                activeClassName="navlinkcolor"
              >
                Soccer
              </NavLink>
            </li>
            <li className="nav-item mr-3">
              <NavLink
                to="/cricket"
                className="nav-link  font-weight-bold text-white"
                activeClassName="navlinkcolor"
              >
                Cricket
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink
                to="/formula-home"
                className="nav-link text-white font-weight-bold text-white"
                activeClassName="navlinkcolor"
              >
                Formula
              </NavLink>
            </li>
          </ul> */}
        </div>
      </nav>
      <div className="under-navbar-bg "></div>
      <br />
    </div>
  );
};

export default Navbar;
